<template>
	<section>
		<!-- shortcut -->
		<div class="su-shortcut">
			<su-container flex>
				<div class="su-shortcut__left">{{$i18n.t('PageHeader.欢迎您走进琴航科技')}}!</div>
				<div class="su-shortcut__right">
					<div class="su-header__options flex al-cn">
						<el-dropdown @command="localeFn">
							<div class="flex al-cn">
								<div class="su-header__lang">{{ languageValue }}</div>
								<i class="el-icon-arrow-down el-icon--right"></i>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="item.value" v-for="(item,i) in localeList"
									:key="i">{{item.label}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<!-- 用户信息 -->
					<el-popover v-if="login" placement="bottom" width="100" trigger="click">
						<div class="user-popover-content">
							<div class="popover-item" @click="$router.push('/me')">{{ $i18n.t('Card1.个人中心') }}</div>
							<div class="popover-item" @click="handleLogout">{{ $i18n.t('Card1.退出登录') }}</div>
						</div>
						<div slot="reference" class="su-header__user flex al-cn">
							<span class="su-header__user-name" v-if="!isPhone">{{ userInfo?.nickName|| '' }}</span>
							<i v-else class="el-icon-user"></i>
							<i class="el-icon-arrow-down el-icon--right"></i>
						</div>
					</el-popover>
					<!-- 登录注册按钮 -->
					<div v-else>
						<div class="su-header__login-btn" @click="goToLogin">
							{{ $i18n.t('PageHeader.登录/注册') }}</div>
					</div>
				</div>
			</su-container>
		</div>
		<!-- header -->
		<header class="su-header flex ju-sb">
			<su-container flex>
				<div class="flex al-cn">
					<img class="su-header__logo" :src="logoImg" alt="" @click="goHome" />
				</div>
				<!-- 移动端汉堡按钮 -->
				<div class="su-header__mobile-toggle" @click="toggleMobileMenu" v-if="isPhone">
					<span></span>
					<span></span>
					<span></span>
				</div>
				<!-- PC端导航 -->
				<div class="su-header__right" v-if="!isPhone">
					<div class="su-header__tabs flex al-cn">
						<div v-for="(tabItem, index) in tabOptions" :key="index">
							<div v-if="tabItem.name!='解决方案'" class="su-header__tab-item" :class="{'itemFont': locale!='zh_CN'}" :title="tabItem.name" @click="headClick(tabItem)">
								{{ $i18n.t('PageHeader.' + tabItem.name) }}
							</div>
							<el-dropdown v-else @command="solutionsFn" placement="top-start">
								<div class="su-header__tab-item" :class="{'itemFont': locale!='zh_CN'}" :title="tabItem.name">
									{{ $i18n.t('PageHeader.' + tabItem.name) }}
								</div>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item :command="item.id" v-for="(item,i) in solutionList"
										:key="i">{{ item.noticeTitle }}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</div>
				</div>

			</su-container>
		</header>

		<!-- 移动端导航菜单 -->
		<div class="su-header__mobile-menu" :class="{'su-header__mobile-menu--active': isMobileMenuOpen}"
			v-if="isPhone">
			<!-- 移动端导航项 -->
			<div v-for="(tabItem, index) in tabOptions" :key="index" class="su-header__mobile-item"
				@click="mobileNavClick(tabItem)">
				{{ $i18n.t('PageHeader.' + tabItem.name) }}
			</div>
		</div>
	</section>
</template>
<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		fanganListApi
	} from '@/api/zhao'

	export default {
		name: 'PageHeader',
		components: {},
		data() {
			return {
			tabOptions: [{
					name: '首页',
					url: 'home'
				},
				{
					name: '供应大厅',
					url: 'product-list',
					title: '富文本详情页'
				},
			{
				name: '二手飞机库',
				url: '',
				title: 'https://www.aviationtrader.com.au'
			},
			{
				name: '采购大厅',
				url: 'purchase-list',
				title: '文章信息'
			},
			{
				name: '招采平台',
				url: '',
				title: 'https://zcz.e99.cn'
			}, // http://ushare.mesnac.com/pc
				{
					name: '备件商城',
					url: '',
					title: 'https://shop.e99.cn'
				},
				{
					name: '解决方案',
					url: 'solution',
					title: 'http://www.mesiic.com/'
				},
				// { name: '新闻中心', url: 'news-list', title: '富文本详情页' },
				{
					name: '关于我们',
					url: 'about3',
					title: '富文本详情页'
				},
			],
				cityList: [],
				isPhone: false,
				isMobileMenuOpen: false,
				drawer: false,
				logoImg: require('@/assets/image/logo.png'),
				login: false,
				languageValue: '',
				solutionList: [],
				localeList: [],
				locale: 'en_US',
				isUrl:''
			}
		},
		computed: {
			...mapGetters(['userInfo']),
		},
		created() {
			this.checkMobile()

			this.$util.getDict('locale').then((ress) => {
				console.log('语言字典', ress)
				this.localeList = ress
				let obj = this.localeList.find(item => item.value == this.$i18n.locale)
				this.languageValue = obj.label

			})
			fanganListApi({'status':'1'},null).then(res => {
				if (res.data.length) {
					this.solutionList = res.data.reverse()
					// 单轴陀螺仪解决方案
				}
			})
			// 监听窗口大小变化，实时更新isPhone状态
			window.addEventListener('resize', this.checkMobile)
		},
		mounted() {
			console.log('当前语言', this.$i18n.locale)
			if (this.$i18n.locale == 'en_US') {
				this.languageValue = 'English'
			}
			if (this.$store.state.user.token) {
				this.login = true
			} else {
				this.login = false
			}
			this.locale = this.$i18n.locale

			// 添加点击事件监听，点击页面其他区域时关闭移动菜单
			document.addEventListener('click', this.handleClickOutside)
		},
		// 监听$store.state.user.token
		watch: {
			'$store.state.user.token': function(newVal) {
				if (newVal) {
					this.login = true
				} else {
					this.login = false
				}
			},
			'$route.path':function(newVal){
				if (newVal) {
					this.isUrl = newVal
					console.log(this.isUrl)
				}
			}
		},
		methods: {
			goHome() {
				this.$router.push('/home')
			},
			// 跳转到登录页面，并传递当前页面路由信息
			goToLogin() {
				const currentRoute = this.$route.fullPath;
				// 将当前路由作为查询参数传递给登录页面
				this.$router.push({
					path: '/login',
					query: {
						redirect: currentRoute
					}
				});
			},
			handleLogout() {
				// 处理退出登录的逻辑
				this.$confirm(this.$i18n.t('Card1.是否确认退出?'), this.$i18n.t('Card1.提示'), {
					confirmButtonText: this.$i18n.t('Card1.确定'),
					cancelButtonText: this.$i18n.t('Card1.取消'),
					type: 'warning'
				}).then(() => {
					this.$store.dispatch('LogOut').then(() => {
						this.$router.push({
							path: '/login'
						})
					})
					this.$message({
						type: 'success',
						message: this.$t('PageHeader.已退出登录')
					})
				}).catch(() => {})
			},
			solutionsFn(val) {
				let obj = this.solutionList.find(item => item.id == val)
				console.log('当前解决方案', obj)
				if (obj) {
					if (obj.id == "1912791772364697602") {
						this.$router.push('/solution?id=' + obj.id) // 无人机供应链
					}
					if (obj.id == "1917064383483559938") {
						this.$router.push('/solution2?id=' + obj.id) // 应急救援
					}
					if (obj.id == "1917064256010272769") {
						this.$router.push('/solution3?id=' + obj.id) // 安防光电
					}
					if (obj.id == "1917064462806237186") {
						this.$router.push('/solution?id=' + obj.id) // 芯片
					}
					if (obj.id == "1927968031734472705"||obj.id == "1927531713195888642") {
						this.$router.push('/solution4?id=' + obj.id) // 单轴陀螺仪
					}
				}
			},
			localeFn(val) {
				console.log('切换语言', val)
				this.locale = val
				this.$i18n.locale = val
				let obj = this.localeList.find(item => item.value == val)
				this.languageValue = obj.label
				localStorage.setItem('locale', val)
				
				// 根据选择的语言构建对应的域名
				const hostname = window.location.hostname;
				const currentPath = window.location.pathname + window.location.search;
				console.log('切换前路由', currentPath)
				// 构建新的URL
				let newUrl;
				if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('192.168.')) {
					// 本地开发环境，刷新页面即可
					location.reload();
				} else {
					// 生产环境，根据语言选择对应的域名
					if (val === 'zh_CN') {
						// 中文：使用cn域名，并带上当前路由
						newUrl = `https://cn.e99.cn${currentPath}`;
					} else if (val === 'en_US') {
						// 英语：使用www域名，并带上当前路由
						newUrl = `https://www.e99.cn${currentPath}`;
					} else if (val === 'tr_TR') {
						// 土耳其语：使用turkey域名，并带上当前路由
						newUrl = `https://turkey.e99.cn${currentPath}`;
					} else if(val == 'ru_RU'){
						// 俄语：使用ru域名，并带上当前路由
						newUrl = `https://russian.e99.cn${currentPath}`;
					} else {
						// 默认英语，并带上当前路由
						newUrl = `https://www.e99.cn${currentPath}`;
					}
					window.open(newUrl);
				}
			},
			// 判断是否移动端
			checkMobile() {
				// 平板和手机都算作移动端
				this.isPhone = window.innerWidth < 992 ? true : false
			},
			// 电脑端点击导航栏菜单
			headClick(data) {
				if (data.url && data.url.length < 20) {
					if (this.$route.path.slice(1) != data.url) {
						if (data.name == '个人中心' && !this.$store.getters.token && this.$route.path != '/login') {
							this.$confirm('您还未登录，请先前往登录！', '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									// type: 'warning',
									center: true,
									confirmButtonClass: 'el-button--warning',
								})
								.then(() => {
									this.drawer = false
									// 跳转到登录页面并传递当前路由信息
									const currentRoute = this.$route.fullPath;
									this.$router.push({
										path: '/login',
										query: {
											redirect: currentRoute
										}
									});
								})
								.catch(() => {})
						} else {
							this.drawer = false
							if (data.val) {
								localStorage.setItem('twoHtml', JSON.stringify(data))
							}
							this.$router.push(data.url + (data.val ? '?id=' + data.val : ''))
						}
					}
				} else {
					console.log('外部', data)
					window.open(data.title || 'https://zcz.e99.cn')
				}
			},
			// 移动端点击导航菜单
			mobileNavClick(data) {
				this.headClick(data)
				this.toggleMobileMenu()
			},
			// 切换移动端菜单显示状态
			toggleMobileMenu() {
				this.isMobileMenuOpen = !this.isMobileMenuOpen
			},
			// 处理点击页面其他区域时关闭移动菜单
			handleClickOutside(e) {
				if (this.isMobileMenuOpen &&
					!e.target.closest('.su-header__mobile-menu') &&
					!e.target.closest('.su-header__mobile-toggle')) {
					this.isMobileMenuOpen = false
				}
			}
		},
		beforeDestroy() {
			// 移除事件监听器
			window.removeEventListener('resize', this.checkMobile)
			document.removeEventListener('click', this.handleClickOutside)
		}
	}
</script>
<style lang="less">
	.su-shortcut {
		background-color: rgba(239, 239, 239, 1);
		height: 48px;
		display: flex;
		align-items: center;
		position: relative;
		z-index: 150;

		.su-shortcut__left {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #666;
		}

		.su-shortcut__right {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: flex-end;
		}
	}

	// 添加用户下拉菜单样式
	.user-popover-content {
		.popover-item {
			padding: 12px 0;
			text-align: left;
			cursor: pointer;
			transition: all 0.3s;
			font-weight: normal;
			color: #333;

			&:hover {
				color: var(--primary-color);
			}

			&:not(:last-child) {
				border-bottom: 1px solid #eee;
			}
		}
	}

	.su-header {
		height: 100px;
		background: #ffffff;
		position: sticky;
		top: 0;
		z-index: 100;

		&__logo {
			height: 50px;
			display: block;
			margin-right: 20px;
		}

		&__right {
			max-width: 60%;
			overflow: auto;
			.su-header__tabs {
				font-family: SourceHanSansCN, SourceHanSansCN;
				color: #333;
				font-style: normal;
				height: 100%;
			}
		}

		&__tab-item {
			padding: 0 14px;
			cursor: pointer;
			text-align: center;
			white-space: nowrap;
			font-size: 18px;
			font-weight: normal;
			transition: all 0.3s ease;

			&:hover {
				color: var(--primary-color);
			}
		}
		.itemFont{
			font-size: 13px;
		}

		&__options {
			cursor: pointer;
		}

		&__lang {
			margin: 0 5px;
		}

		&__user {
			margin-left: 20px;
			font-size: 14px;
			display: flex;
			align-items: center;
			justify-content: center;

			&-name {
				margin-left: 10px;
				color: var(--primary-color);
			}
		}

		&__login-btn {
			// width: 85px;
			padding: 0 10px;
			height: 24px;
			border-radius: 2px;
			border: 1px solid #158e58;

			font-family: SourceHanSansCN, SourceHanSansCN;
			font-weight: 500;
			font-size: 14px;
			color: var(--primary-color);
			line-height: 24px;
			font-style: normal;

			text-align: center;
			margin-left: 20px;
			cursor: pointer;
		}



		/* 移动端汉堡按钮 */
		&__mobile-toggle {
			display: none;
			flex-direction: column;
			justify-content: space-between;
			width: 24px;
			height: 18px;
			cursor: pointer;
			z-index: 101;
			margin-left: auto;

			span {
				display: block;
				height: 2px;
				width: 100%;
				background-color: #333;
				border-radius: 2px;
				transition: all 0.3s ease;
			}
		}

		/* 移动端导航菜单 */
		&__mobile-menu {
			position: fixed;
			top: 100px;
			left: 0;
			right: 0;
			background-color: white;
			padding: 20px;
			box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
			z-index: 99;
			display: flex;
			flex-direction: column;
			transform: translateY(-100%);
			opacity: 0;
			transition: all 0.3s ease;
			pointer-events: none;
			box-sizing: border-box;
			max-width: 100vw;
			overflow-x: hidden;

			&--active {
				transform: translateY(0);
				opacity: 1;
				pointer-events: auto;
			}
		}

		&__mobile-item {
			font-size: 16px;
			color: #333;
			text-decoration: none;
			padding: 15px 0;
			border-bottom: 1px solid #f0f0f0;
			transition: all 0.3s ease;

			&:last-child {
				border-bottom: none;
			}

			&:hover {
				color: var(--primary-color);
			}
		}


	}
	/* 笔记本响应式 */
	@media (max-width: 1366px) {
		.su-header {
			&__logo {
				height: 46px;
			}
		}
	}
	/* 响应式样式 */
	@media (max-width: 1200px) {
		.su-header {
			&__tab-item {
				padding: 0 10px;
				font-size: 16px;
			}
		}
	}

	/* 平板响应式 */
	@media (max-width: 992px) {
		.su-header {
			&__mobile-toggle {
				display: flex;
			}

			&__logo {
				height: 40px;
			}
		}

		.su-shortcut {
			height: 40px;

			.su-shortcut__left {
				font-size: 14px;
			}
		}
	}

	/* 手机端响应式 */
	@media (max-width: 768px) {
		.su-header {
			height: 70px;

			&__logo {
				height: 32px;
			}

			&__mobile-menu {
				top: 100px;
				padding: 10px;
				width: 100%;
			}
		}

		.su-shortcut {
			height: 36px;

			.su-shortcut__left {
				font-size: 12px;
			}

			.su-header__options {
				font-size: 12px;
			}

			.su-header__login-btn {
				font-size: 12px;
				height: 20px;
				line-height: 20px;
				margin-left: 10px;
			}
		}
	}

	/* 小屏手机响应式 */
	@media (max-width: 480px) {
		.su-shortcut {
			.su-shortcut__left {
				color: #999;
			}
		}

		.su-header {
			&__mobile-menu {
				padding: 8px;
			}
		}
	}

	/* 用户图标样式 */
	.su-header__user {
		.el-icon-user {
			font-size: 20px;
			color: var(--primary-color);
		}
	}
</style>
<style scoped>
	/* 定义滚动条整体样式 */
	::-webkit-scrollbar {
		width: 8px; /* 滚动条宽度 */
		height: 8px; /* 滚动条高度 */
	}
	/* 定义滚动条滑块样式 */
	::-webkit-scrollbar-thumb {
		background: #ccc; /* 滑块颜色 */
		border-radius: 6px; /* 滑块圆角 */
	}
	/* 定义滚动条轨道样式 */
	::-webkit-scrollbar-track {
		background: #f5f5f5; /* 轨道颜色 */
		border-radius: 6px; /* 轨道圆角 */
	}
</style>